var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-navigation'),_c('div',{class:[
      'view',
      { 'view-no-margin' : _vm.$route.name === 'index' }
    ]},[_c('transition',{attrs:{"name":_vm.activeTransition,"mode":"out-in"}},[_c('router-view')],1)],1),_c('loading-default',{attrs:{"loadingVisible":_vm.$store.getters.globalLoading,"headline":_vm.loadingHeadline,"excerpt":_vm.loadingExcerpt}}),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }